export default "__VITE_ASSET__679838ea__"